import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './login.css';

// // import { Button } from "react-bootstrap";
import { Button } from 'reactstrap';
import background from '../../images/background.svg';

import logo from '../../images/logo.svg';
import authStore from '../../../stores/auth-store';
import queryString from 'query-string'
import LoginLoader from "./LoginLoader";


class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            password: "",
            Invalid: false,
            isLoading: false,
            isMobile: false,
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    // handleSubmit = event => {
    //     event.preventDefault();
    //     if (this.state.email === 'admin' && this.state.password === 'admin') {
    //         //localStorage.setItem("isAuth", true);
    //         this.props.history.push('/load-manager')
    //     }
    // }

    //       componentDidMount=()=>{
    // 	   const socket = socketIOClient(urls.mainApiUrl);
    // 	   jumpersStore.loadAllJumpers()
    // 	   .then((jumpersLoaded) =>{
    // 		   //console.log('after loadAll Jumpers');
    // 		   return jumpersStore.loadTandemStudents();
    // 	   })
    // 	   .then((studentsLoaded)=>{
    // 		   //console.log("after load all students");
    // 		   return loadsStore.loadAllExistingLoads();
    // 	   })
    // 	   .then(loads=>{
    // 		   loadsStore.setListeners(socket);
    // 	   })
    //   }



    componentDidMount() {
        window.onresize = this.handleWindowResize;
        this.handleWindowResize();
        const values = queryString.parse(this.props.location.search)
        if (values.verification) {
            authStore.verifyEmail({ verificationCode: values.verification }).then(res => {
                toast.info("Account verified successfully")
            }).catch(err => {
                toast.error("Some error occures while verifing your account")
            })
        }

        if (values.username !== undefined && values.password != undefined) {
            authStore.login({ username: values.username, password: values.password })
                .then(data => {
                    //console.log(data);
                    if (data.success) {
                        localStorage.setItem("isAuth", true);
                        localStorage.setItem("Auth-token", data.token);
                        if (data.jumperInfo) localStorage.setItem("jumperDetails", JSON.stringify(data?.jumperInfo))
                        if (data.jumperDetails) {
                            let jumper = JSON.parse(data.jumperDetails);
                            // console.log("🚀 ~ file: Login.js ~ line 103 ~ Login ~ jumper", jumper)
                            jumper = { _id: jumper._id, firstname: jumper.firstname, lastname: jumper.lastname };
                            console.log("jumper",jumper)
                            // localStorage.setItem("jumperDetails", JSON.stringify(jumper));
                        }
                        this.props.history.push('/')
                        window.location.reload(true);
                    }
                    else {
                        if (data = 'Unauthorized') {
                            toast.error("Opps... Invalid login")
                        }
                    }

                });
        }

    }
    hideLoader = (isErr, message) => {
        // add fadeout animation class
        let loginContainer = document.querySelector(".loginloader-container");
        if (loginContainer) {
            loginContainer.classList.add('fade-out-loader');
        }

        let time = setTimeout(() => {
            // this.setState({ isLoading: false })
            if (!isErr) {
                // console.log("hideLOder and redierect")
                // this.props.history.push('/load-manager')
                window.location.replace('/load-manager')
            }
            else {
                this.setState({ isLoading: false })
                toast.error(message)
            }
            clearTimeout(time);
        }, 500)
    }
    handleSubmit = event => {
        let { username, password } = this.state;
        this.setState({
            isLoading: true,
        })
        event.preventDefault();
        console.log("ueer: ", username, password);
        if (username && password) {
            authStore.login({ username, password })
                .then(data => {
                    if (data.success && data.isVerified) {
                        localStorage.setItem("isAuth", true);
                        localStorage.setItem("Auth-token", data.token);
                        console.log(data.jumperDetails, 'jumperdtaj')
                        if (data.jumperInfo) localStorage.setItem("jumperDetails", JSON.stringify(data?.jumperInfo))
                        if (data.jumperDetails) {
                            let jumper = JSON.parse(data.jumperDetails);
                            // console.log("🚀 ~ file: Login.js ~ line 103 ~ Login ~ jumper", jumper)
                            jumper = { _id: jumper._id, firstname: jumper.firstname, lastname: jumper.lastname };
                            console.log("jumper",jumper)
                            // localStorage.setItem("jumperDetails", JSON.stringify(jumper));
                        }
                        this.props.history.push('/')
                        window.location.reload(true);

                        this.hideLoader(false) // isErr false
                    }
                    else {
                        let msgErr = data.message;
                        if (data == 'Unauthorized') {
                            msgErr = "Opps.. Invalid Login";
                        } else if (!data.isVerified) {
                            msgErr = "Account not verified";
                        }
                        this.hideLoader(true, msgErr)  // when there is error
                    }
                }).catch(err => {
                    this.hideLoader(true, "Server Error!!")  // when there is error
                })
        } else {
            this.hideLoader(true, "Please fill all fields properly!!")
        }
    }

    handleWindowResize = () => {
        let isMobile = window.innerWidth <= 500;
        this.setState({ isMobile })
    }

    render() {
        let { isLoading, isMobile, username, password } = this.state
        return (

            isLoading ?
                <LoginLoader />
                :
                <div className="container-fluid " >
                    {/* <!-- login page start--> */}
                    <div className="authentication-main">
                        <div className="row">
                            <div className="col-md-12 pl-0">
                                <div className="auth-innerright">
                                    <div className="authentication-box">
                                        <div className="text-center">
                                            <img src={logo} alt="" />
                                        </div>
                                        <div className="card mt-4">
                                            <div className="card-body auth-cardbody">
                                                <div className="text-center">
                                                    <h4>LOGIN</h4>
                                                    <h6>{"Enter your Username and Password"} </h6>
                                                </div>
                                                <form className="theme-form" >
                                                    <div className="form-group">
                                                        <label className="col-form-label pt-0">Username</label>
                                                        <input className="form-control" type="username" name="username"
                                                            value={username}
                                                            onChange={this.handleChange}
                                                            id="username"
                                                            placeholder="Enter Username"
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="col-form-label">Password</label>
                                                        <input className="form-control" type="password" name="password"
                                                            value={password}
                                                            id="password"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                    <div className="form-group form-row mt-3 mb-0">
                                                        <button className="btn btn-primary btn-block" type="button" onClick={this.handleSubmit} >
                                                            LOGIN
                                                    </button>
                                                    </div>
                                                    {
                                                        isMobile ?
                                                            <div className="textRightLink">
                                                                <div onClick={() => this.props.history.push('/signup')} >
                                                                    New here ? Create new account
                                                                </div>
                                                                <div onClick={() => this.props.history.push('/forgot')} className="below">
                                                                    Forgot password ?
                                                                </div>
                                                            </div>
                                                            : null
                                                    }
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <ToastContainer autoClose={3000} />
                    {/* <!-- login page end--> */}
                </div>

        );
    }
}
export default withRouter(Login)
